import crudApi from "./crudApi";
import {API_SALE_TYPES} from "../api";

class SaleTypes extends crudApi{}

export default new SaleTypes(API_SALE_TYPES);
